/*------ ITG Ck of Js 30-06-2023------ */
$(document).ready(function() {
  
   var genrate_blank = `<table>
    <thead>
      <th style="text-transform: capitalize;">Item<br/></th>
      <th style="text-transform: capitalize;">Calories <br/><span style="text-transform: lowercase"></span></th>
      <th style="text-transform: capitalize;">Protein <br/><span style="text-transform: lowercase">(g)</span></th>
      <th style="text-transform: capitalize;">Carbs <br/><span style="text-transform: lowercase">(g)</span></th>
      <th style="text-transform: capitalize;">Fats <br/><span style="text-transform: lowercase">(g)</span></th>
      <th style="text-transform: capitalize;">Sodium <br/><span style="text-transform: lowercase">(mg)</span></th>
    </thead>
    <tbody class="data_nutritionData_ck">
    <tbody>
    <tfoot class="total_calcultion_nutritionData_ck">
      <th style="text-transform: capitalize;">Total</th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
    </tfoot>
    </table>`;

    $('#nutrition-container').html(genrate_blank);
    $('#nutrition-container').hide();
    $('.data_nutritionData_ck').html('');
 
     $(document).on('change','.bold_option.bold_option_swatch input[type="checkbox"],select[name="properties[Add seasoning?]"]',function() {
      var nutritionFact = {
        /* Carb */
        "White Rice 1/4": {
          "calorie": 39,
          "protein": 1,
          "carb": 8,
          "fats": 0,
          "sodium": 1
        },
       "White Rice 1/2": {
          "calorie": 77,
          "protein": 2,
          "carb": 17,
          "fats": 0,
          "sodium": 2
        },
         "White Rice 3/4": {
          "calorie": 166,
          "protein": 2.75,
          "carb": 25,
          "fats": 0,
          "sodium": 3
        },
         "White Rice 1": {
          "calorie": 155,
          "protein": 3.75,
          "carb": 33,
          "fats": 0,
          "sodium": 5
        },

         "Brown Rice 1/4": {
          "calorie": 52,
          "protein": 1,
          "carb": 11,
          "fats": 0,
          "sodium": 2
        },
       "Brown Rice 1/2": {
          "calorie": 103,
          "protein": 2,
          "carb": 22,
          "fats": 1,
          "sodium": 4
        },
         "Brown Rice 3/4": {
          "calorie": 155,
          "protein": 3,
          "carb": 33,
          "fats": 1,
          "sodium": 5
        },
         "Brown Rice 1": {
          "calorie": 207,
          "protein": 4,
          "carb": 44,
          "fats": 1.5,
          "sodium": 7
        },


        "Diced Potato 1/4": {
          "calorie": 37,
          "protein": 1,
          "carb": 7,
          "fats": 1,
          "sodium": 14
        },
       "Diced Potato 1/2": {
          "calorie": 73,
          "protein": 2,
          "carb": 14,
          "fats": 1.5,
          "sodium": 28
        },
         "Diced Potato 3/4": {
          "calorie": 110,
          "protein": 2,
          "carb": 20,
          "fats": 2.5,
          "sodium": 42
        },
         "Diced Potato 1": {
          "calorie": 146,
          "protein": 3,
          "carb": 27,
          "fats": 3,
          "sodium": 57
        },

        
        "Wild Rice 1/4": {
          "calorie": 45,
          "protein": 2,
          "carb": 9,
          "fats": 0,
          "sodium": 2
        },
       "Wild Rice 1/2": {
          "calorie": 89,
          "protein": 4,
          "carb": 19,
          "fats": 0,
          "sodium": 3
        },
         "Wild Rice 3/4": {
          "calorie": 134,
          "protein": 6,
          "carb": 28,
          "fats": 0,
          "sodium": 5
        },
         "Wild Rice 1": {
          "calorie": 179,
          "protein": 7,
          "carb": 38,
          "fats": 0.5,
          "sodium": 7
        },

        
        "Mashed Coconut Sweet Potato 1/4": {
          "calorie": 76,
          "protein": 1,
          "carb": 17,
          "fats": 0.5,
          "sodium": 12
        },
       "Mashed Coconut Sweet Potato 1/2": {
          "calorie": 152,
          "protein": 2,
          "carb": 34,
          "fats": 1,
          "sodium": 23
        },
         "Mashed Coconut Sweet Potato 3/4": {
          "calorie": 228,
          "protein": 3,
          "carb": 51,
          "fats": 1.5,
          "sodium": 35
        },
         "Mashed Coconut Sweet Potato 1": {
          "calorie": 303,
          "protein": 3,
          "carb": 68,
          "fats": 2,
          "sodium": 47
        },

        /* Protien */
        
        "Chicken Breast 3": {
          "calorie": 140,
          "protein": 26,
          "carb": 0,
          "fats": 3,
          "sodium": 63
        },
         "Chicken Breast 4": {
          "calorie": 187,
          "protein": 35,
          "carb": 0,
          "fats": 4,
          "sodium": 84
        },
         "Chicken Breast 5": {
          "calorie": 233,
          "protein": 44,
          "carb": 0,
          "fats": 5,
          "sodium": 105
        },
           "Chicken Breast 6": {
          "calorie": 280,
          "protein": 53,
          "carb": 0,
          "fats": 6,
          "sodium": 126
        },
          "Chicken Breast 7": {
          "calorie": 327,
          "protein": 61,
          "carb": 0,
          "fats": 7,
          "sodium": 147
        },
          "Chicken Breast 8": {
          "calorie": 327,
          "protein": 70,
          "carb": 0,
          "fats": 8,
          "sodium": 168
        },

        "Chicken Thigh 3": {
          "calorie": 148,
          "protein": 22,
          "carb": 0,
          "fats": 6,
          "sodium": 73
        },
         "Chicken Thigh 4": {
          "calorie": 197,
          "protein": 30,
          "carb": 0,
          "fats": 8,
          "sodium": 97
        },
         "Chicken Thigh 5": {
          "calorie": 246,
          "protein": 37,
          "carb": 1,
          "fats": 10,
          "sodium": 121
        },
           "Chicken Thigh 6": {
          "calorie": 295,
          "protein": 45,
          "carb": 1,
          "fats": 12,
          "sodium": 146
        },
          "Chicken Thigh 7": {
          "calorie": 345,
          "protein": 52,
          "carb": 1,
          "fats": 15,
          "sodium": 170
        },
          "Chicken Thigh 8": {
          "calorie": 394,
          "protein": 60,
          "carb": 1,
          "fats": 17,
          "sodium": 194
        },

          "Flank Steak 3": {
           "calorie":142,
          "protein":22,
          "carb":0,
          "fats":7,
          "sodium":180
        },
         "Flank Steak 4": {
          "calorie": 190,
          "protein": 29,
          "carb": 0,
          "fats": 9,
          "sodium": 241
        },
         "Flank Steak 5": {
          "calorie": 237,
          "protein": 37,
          "carb": 0,
          "fats": 11,
          "sodium": 301
        },
           "Flank Steak 6": {
          "calorie": 285,
          "protein": 44,
          "carb": 0,
          "fats": 14,
          "sodium": 361
        },
          "Flank Steak 7": {
          "calorie": 332,
          "protein": 52,
          "carb": 0,
          "fats": 16,
          "sodium": 421
        },
          "Flank Steak 8": {
          "calorie": 380,
          "protein": 59,
          "carb": 0,
          "fats": 18,
          "sodium": 481
        },


        "Ground Beef 3": {
           "calorie":209,
          "protein":22,
          "carb":2,
          "fats":13,
          "sodium":295
        },
         "Ground Beef 4": {
          "calorie": 279,
          "protein": 30,
          "carb": 0,
          "fats": 17,
          "sodium": 393
        },
         "Ground Beef 5": {
          "calorie": 349,
          "protein": 37,
          "carb": 0,
          "fats": 21,
          "sodium": 491
        },
           "Ground Beef 6": {
          "calorie": 419,
          "protein": 45,
          "carb": 0,
          "fats": 25,
          "sodium": 589
        },
          "Ground Beef 7": {
          "calorie": 489,
          "protein": 52,
          "carb": 0,
          "fats": 29,
          "sodium": 687
        },
          "Ground Beef 8": {
          "calorie": 559,
          "protein": 60,
          "carb": 0,
          "fats": 34,
          "sodium": 785
        },


        "Shredded Beef 3": {
           "calorie":124,
          "protein":22,
          "carb":0,
          "fats":4,
          "sodium":72
        },
         "Shredded Beef 4": {
          "calorie": 166,
          "protein": 29,
          "carb": 0,
          "fats": 5,
          "sodium": 96
        },
         "Shredded Beef 5": {
          "calorie": 207,
          "protein": 37,
          "carb": 0,
          "fats": 6,
          "sodium": 120
        },
           "Shredded Beef 6": {
          "calorie": 249,
          "protein": 44,
          "carb": 0,
          "fats": 8,
          "sodium": 144
        },
          "Shredded Beef 7": {
          "calorie": 290,
          "protein": 51,
          "carb": 0,
          "fats": 9,
          "sodium": 168
        },
          "Shredded Beef 8": {
          "calorie": 332,
          "protein": 59,
          "carb": 0,
          "fats": 10,
          "sodium": 192
        },

         "Turkey Breast 3": {
           "calorie":123,
          "protein":27,
          "carb":0,
          "fats":2,
          "sodium":55
        },
         "Turkey Breast 4": {
          "calorie": 164,
          "protein": 35,
          "carb": 0,
          "fats": 2.5,
          "sodium": 74
        },
         "Turkey Breast 5": {
          "calorie": 205,
          "protein": 44,
          "carb": 0,
          "fats": 3,
          "sodium": 92
        },
         "Turkey Breast 6": {
          "calorie": 246,
          "protein": 53,
          "carb": 0,
          "fats": 3.5,
          "sodium": 111
        },
          "Turkey Breast 7": {
          "calorie": 287,
          "protein": 62,
          "carb": 0,
          "fats": 4,
          "sodium": 129
        },
          "Turkey Breast 8": {
          "calorie": 328,
          "protein": 71,
          "carb": 0,
          "fats": 5,
          "sodium": 148
          },


         "Ground Turkey 3": {
           "calorie":214,
          "protein":22,
          "carb":0,
          "fats":14,
          "sodium":75
        },
         "Ground Turkey 4": {
          "calorie": 286,
          "protein": 30,
          "carb": 0,
          "fats": 18,
          "sodium": 99
        },
         "Ground Turkey 5": {
          "calorie": 357,
          "protein": 37,
          "carb": 0,
          "fats": 23,
          "sodium": 124
        },
         "Ground Turkey 6": {
          "calorie": 429,
          "protein": 45,
          "carb": 0,
          "fats": 28,
          "sodium": 149
        },
          "Ground Turkey 7": {
          "calorie": 500,
          "protein": 52,
          "carb": 0,
          "fats": 32,
          "sodium": 174
        },
          "Ground Turkey 8": {
          "calorie": 572,
          "protein": 60,
          "carb": 0,
          "fats": 37,
          "sodium": 199
          },


        /// veg 
         "Green Beans 1/4": {
          "calorie": 10,
          "protein": 1,
          "carb": 2,
          "fats": 0,
          "sodium": 0
          },
          "Green Beans 1/2": {
          "calorie": 20,
          "protein": 1,
          "carb": 5,
          "fats": 0,
          "sodium": 0
          },
        "Green Beans 3/4": {
          "calorie": 35,
          "protein": 2,
          "carb": 7,
          "fats": 0,
          "sodium": 0
          },
          "Green Beans 1": {
          "calorie": 45,
          "protein": 2,
          "carb": 10,
          "fats": 0,
          "sodium": 0
          },


        "Brocolli 1/4": {
          "calorie": 15,
          "protein": 1,
          "carb": 3,
          "fats": 0,
          "sodium": 15
          },
          "Brocolli 1/2": {
          "calorie": 25,
          "protein": 2,
          "carb": 6,
          "fats": 0,
          "sodium": 30
          },
        "Brocolli 3/4": {
          "calorie": 40,
          "protein": 3,
          "carb": 8,
          "fats": 0,
          "sodium": 50
          },
          "Brocolli 1": {
          "calorie": 50,
          "protein": 4,
          "carb": 11,
          "fats": 0.5,
          "sodium": 65
          },


         "Brussel Sprouts 1/4": {
          "calorie": 15,
          "protein": 1,
          "carb": 3,
          "fats": 0,
          "sodium": 10
          },
          "Brussel Sprouts 1/2": {
          "calorie": 30,
          "protein": 2,
          "carb": 6,
          "fats": 0,
          "sodium": 15
          },
          "Brussel Sprouts 3/4": {
          "calorie": 40,
          "protein": 3,
          "carb": 8,
          "fats": 0.5,
          "sodium": 25
          },
          "Brussel Sprouts 1": {
            "calorie": 60,
            "protein": 4,
            "carb": 11,
            "fats": 1,
            "sodium": 35
          },

         "Cauliflower 1/4": {
          "calorie": 5,
          "protein": 1,
          "carb": 1,
          "fats": 0,
          "sodium": 0
          },
          "Cauliflower 1/2": {
          "calorie": 15,
          "protein": 1,
          "carb": 3,
          "fats": 0,
          "sodium": 10
          },
          "Cauliflower 3/4": {
          "calorie": 20,
          "protein": 2,
          "carb": 4,
          "fats": 0,
          "sodium": 15
          },
          "Cauliflower 1": {
            "calorie": 30,
            "protein": 2,
            "carb": 5,
            "fats": 0.5,
            "sodium": 20
          },

                 
          "Zoodles 1/4": {
          "calorie": 5,
          "protein": 0,
          "carb": 1,
          "fats": 0,
          "sodium": 0
          },
          "Zoodles 1/2": {
          "calorie": 10,
          "protein": 1,
          "carb": 2,
          "fats": 0,
          "sodium": 0
          },
          "Zoodles 3/4": {
          "calorie": 15,
          "protein": 1,
          "carb": 3,
          "fats": 0,
          "sodium": 5
          },
          "Zoodles 1": {
            "calorie": 20,
            "protein": 2,
            "carb": 4,
            "fats": 0,
            "sodium": 10
          }, 


        
        "Mashed-Coconut Sweet-Potato 1/4": {
          "calorie": 76,
          "protein": 1,
          "carb": 17,
          "fats": 0.5,
          "sodium": 12
        },
        "Mashed-Coconut Sweet-Potato 1/2": {
          "calorie": 152,
          "protein": 2,
          "carb": 34,
          "fats": 1,
          "sodium": 23
        },
         "Mashed-Coconut Sweet-Potato 3/4": {
          "calorie": 228,
          "protein": 3,
          "carb": 51,
          "fats": 1.5,
          "sodium": 35
        },
         "Mashed-Coconut Sweet-Potato 1": {
          "calorie": 303,
          "protein": 3,
          "carb": 68,
          "fats": 2,
          "sodium": 47
        },


          // Sourc
           "Nashville sauce": {
            "calorie": 35,
            "protein": 0,
            "carb": 1,
            "fats": 3.5,
            "sodium": 600
          },
          "Chili verde": {
          "calorie": 10,
          "protein": 0,
          "carb": 2,
          "fats": 0,
          "sodium": 180
        }, 
        "Poutine": {
          "calorie": 10,
          "protein": 0,
          "carb": 2,
          "fats": 0,
          "sodium": 0
        },
        "NA": {
          "calorie": 0,
          "protein": 0,
          "carb": 0,
          "fats": 0,
          "sodium": 0
        }
      } // end of nutritinoFact

    setTimeout(function() {
        $('#nutrition-container').hide();
        $('.data_nutritionData_ck').html('');
        $('.total_calcultion_nutritionData_ck').html('');
        var total_calorie = 0;
        var total_protein = 0;
        var total_carb = 0;
        var total_fats = 0;
        var total_sodium = 0;
        $(document).find('.bold_options[data-product-id="8340982595874"] .bold_option_set').each(function(index) {
            var option_title_value = $(this).find('label .bold_option_title').text().trim();
            var this_option_selection_value = $(this).find('.bold_option_element select').val();
            var this_option_selection_value_only_s = $('.dd_1963969_760459').val();
            var swach_value_selected = $(this).find('.bold_option_element input:checked').val();
            var swach_value_selected_checkbox_ = $(this).find('.bold_option_element input').length;
            var swach_value_selected_check = $(this).find('.bold_option_element input:checked').length;
          if (this_option_selection_value != '' && swach_value_selected_check != 0) {
            var swach_value_selected = swach_value_selected.replace(/oz|Cup/gi,'').toLocaleLowerCase();
            var swach_value_selected = swach_value_selected.trim();
            var nutritionFact_finder = this_option_selection_value+' '+swach_value_selected;

            total_calorie += nutritionFact[nutritionFact_finder]['calorie'];
            total_protein += nutritionFact[nutritionFact_finder]['protein'];
            total_carb += nutritionFact[nutritionFact_finder]['carb'];
            total_fats += nutritionFact[nutritionFact_finder]['fats'];
            total_sodium += nutritionFact[nutritionFact_finder]['sodium'];          
            var nutritionData = `
                            <tr>
                              <td class="item">${(this_option_selection_value)}</td>
                              <td>${nutritionFact[nutritionFact_finder]['calorie']}</td>
                              <td>${nutritionFact[nutritionFact_finder]['protein']}</td>
                              <td>${nutritionFact[nutritionFact_finder]['carb']}</td>
                              <td>${nutritionFact[nutritionFact_finder]['fats']}</td>
                              <td>${nutritionFact[nutritionFact_finder]['sodium']}</td>
                            </tr>
                        `;
            if (option_title_value == 'Protein*') {
              $('.data_nutritionData_ck').prepend(nutritionData);
            } else {
              $('.data_nutritionData_ck').append(nutritionData);
            }
              $('#nutrition-container').show();   
        }
        if ( this_option_selection_value_only_s != '' && index == 2) {
                    var nutritionFact_finder = this_option_selection_value_only_s;
                    total_calorie += nutritionFact[nutritionFact_finder]['calorie'];
                    total_protein += nutritionFact[nutritionFact_finder]['protein'];
                    total_carb += nutritionFact[nutritionFact_finder]['carb'];
                    total_fats += nutritionFact[nutritionFact_finder]['fats'];
                    total_sodium += nutritionFact[nutritionFact_finder]['sodium'];
                    var nutritionData = `<tr>
                                          <td class="item">${(this_option_selection_value_only_s)}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['calorie']}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['protein']}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['carb']}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['fats']}</td>
                                          <td>${nutritionFact[nutritionFact_finder]['sodium']}</td>
                                        </tr> `;
                if (option_title_value == 'Protein*') {
                  $('.data_nutritionData_ck').prepend(nutritionData);
                } else {
                  $('.data_nutritionData_ck').append(nutritionData);
                }
                $('#nutrition-container').show();         
        }
      }).promise().done(function() {
                        var total_nutration_deta = `
                            <th style="text-transform: capitalize;">Total</th>
                              <th>${(total_calorie)}</th>
                              <th>${(total_protein)}</th>
                              <th>${(total_carb)}</th>
                              <th>${(total_fats)}</th>
                              <th>${(total_sodium)}</th>
                        `;
                         $('.total_calcultion_nutritionData_ck').append(total_nutration_deta);
     });
    },300);
  });
});